import { useQueryClient as s, useMutation as c } from "@tanstack/vue-query";
import { campaignKeys as l } from "../campaign/queries.js";
import { adGroupKeys as y } from "./queries.js";
import "../creative-group/queries.js";
import "vue";
import { pricingRuleKeys as u } from "./pricing-rule-keys.js";
const K = (n, t) => {
  const a = s(), r = t?.onSuccess;
  return c({
    ...t,
    mutationFn: async (e) => {
      const { campaignId: i, ...d } = e;
      return n.pricingRule.create(d);
    },
    onSuccess: async (...e) => {
      const [, i] = e;
      await a.invalidateQueries({ queryKey: u.all }), await a.invalidateQueries({ queryKey: y.byCampaign(i.campaignId) }), await a.invalidateQueries({ queryKey: l.all }), r && r(...e);
    }
  });
}, Q = (n, t) => {
  const a = s(), r = t?.onSuccess;
  return c({
    ...t,
    mutationFn: async (e) => {
      const { adGroupId: i, campaignId: d, ...o } = e;
      return n.pricingRule.update(o);
    },
    onSuccess: async (...e) => {
      const [, i] = e;
      await a.invalidateQueries({ queryKey: u.all }), await a.invalidateQueries({ queryKey: y.byCampaign(i.campaignId) }), await a.invalidateQueries({ queryKey: l.all }), r && r(...e);
    }
  });
}, w = (n, t) => {
  const a = s();
  return c({
    ...t,
    mutationFn: async (r) => {
      const { adGroupId: e, campaignId: i, ...d } = r;
      return n.pricingRule.update(d);
    },
    onMutate: async (r) => {
      await a.cancelQueries({
        queryKey: u.detail(r.ruleId)
      });
      const e = a.getQueryData(u.detail(r.ruleId));
      return e !== void 0 ? { previousData: e } : {};
    },
    onError: (r, e, i) => {
      i?.previousData && a.setQueryData(u.detail(e.ruleId), i.previousData);
    },
    onSettled: async (r, e, i) => {
      await a.invalidateQueries({ queryKey: u.all }), await a.invalidateQueries({ queryKey: y.byCampaign(i.campaignId) }), await a.invalidateQueries({ queryKey: l.all });
    }
  });
}, S = (n, t) => {
  const a = s(), r = t?.onSuccess;
  return c({
    ...t,
    mutationFn: async (e) => n.pricingRule.remove({ params: { ruleId: e.ruleId }, query: { force: e.force } }),
    onSuccess: async (...e) => {
      const [, i] = e;
      a.removeQueries({
        queryKey: u.detail(i.ruleId)
      }), await a.invalidateQueries({ queryKey: u.all }), await a.invalidateQueries({ queryKey: y.byCampaign(i.campaignId) }), await a.invalidateQueries({ queryKey: l.all }), r && r(...e);
    }
  });
}, f = (n, t) => {
  const a = s(), r = t?.onSuccess;
  return c({
    ...t,
    mutationFn: async (e) => {
      const { adGroupId: i, campaignId: d, ...o } = e;
      return n.pricingRule.updateStatus(o);
    },
    onSuccess: async (...e) => {
      const [, i] = e;
      await a.invalidateQueries({ queryKey: u.all }), await a.invalidateQueries({ queryKey: y.byCampaign(i.campaignId) }), await a.invalidateQueries({ queryKey: l.all }), r && r(...e);
    }
  });
}, C = (n, t) => {
  const a = s(), r = t?.onSuccess;
  return c({
    ...t,
    mutationFn: async (e) => {
      for (const i of e.updates)
        await n.pricingRule.update({
          ruleId: i.ruleId,
          ...i.data
        });
    },
    onSuccess: async (...e) => {
      const [, i] = e;
      await a.invalidateQueries({ queryKey: u.all }), await a.invalidateQueries({ queryKey: y.byCampaign(i.campaignId) }), await a.invalidateQueries({ queryKey: l.all }), r && r(...e);
    }
  });
};
export {
  C as useBatchUpdatePricingRules,
  K as useCreatePricingRule,
  S as useDeletePricingRule,
  Q as useUpdatePricingRule,
  w as useUpdatePricingRuleOptimistic,
  f as useUpdatePricingRuleStatus
};
//# sourceMappingURL=pricing-rule-mutations.js.map
